"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DashboardInsightSubmenuContainer = void 0;
var tslib_1 = require("tslib");
// (C) 2021-2022 GoodData Corporation
var react_1 = tslib_1.__importDefault(require("react"));
var sdk_ui_kit_1 = require("@gooddata/sdk-ui-kit");
var DashboardInsightSubmenuHeader_1 = require("./DashboardInsightSubmenuHeader");
var screenWrapperStyle = { width: "100%" };
exports.DashboardInsightSubmenuContainer = function (props) {
    return (react_1.default.createElement("div", { className: "configuration-panel" },
        react_1.default.createElement("div", { className: "configuration-panel-header" },
            react_1.default.createElement(DashboardInsightSubmenuHeader_1.DashboardInsightSubmenuHeader, { title: props.title, onHeaderClick: props.onBack }),
            react_1.default.createElement(sdk_ui_kit_1.Button, { className: "gd-button-link gd-button-icon-only gd-icon-cross configuration-panel-header-close-button s-configuration-panel-header-close-button", onClick: props.onClose })),
        react_1.default.createElement("div", { className: "configuration-panel-screen", style: screenWrapperStyle }, props.children)));
};
//# sourceMappingURL=DashboardInsightSubmenuContainer.js.map